import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import classNames from 'classnames';
import { CLogo, CListRow, Text } from '@appcues/component-library';
import { Icon } from 'next/components/ui';

import SpoofingControl from 'components/App/Navbar/SpoofingControl';
import NavTrialMeter from 'components/App/Navbar/NavTrialMeter';
import NavbarMenu from 'components/App/Navbar/NavbarMenu';
import NavbarSection from 'components/App/Navbar/NavbarSection';
import WidgetLink from 'components/App/Navbar/WidgetLink';
import FeatureGate from 'components/Common/FeatureGate/FeatureGate';
import GetHelpLink from 'components/App/Navbar/GetHelpLink';
import AvatarImg from 'components/Common/AvatarImg';
import WebNavItems from 'components/App/Navbar/web';
import { NAV_MODES } from 'constants/navModes';
import { APPCUES_SIDEBAR_WIDGET } from 'constants/features';
import { isSuperUser } from 'helpers/account-management';

export const Context = React.createContext();
const SETTINGS_MENU_LINE_HEIGHT_PX = 18;
const SETTINGS_MENU_PADDING_PX = 20;

const IconExpandMenu = styled(Icon).attrs(() => ({
  icon: 'chevron-right',
}))`
  color: var(--icon);
  font-size: 8px;
`;

const OldNavbar = ({ user, className, isInstalled, meta, navMode }) => {
  const label = meta.company || user.email;
  const isOverlayNavMode = navMode !== NAV_MODES.NORMAL;
  const navModeClass = isOverlayNavMode ? 'overlay-nav' : 'nav';
  const overlayNavClass =
    navMode === NAV_MODES.OVERLAY_OPEN ? 'open' : 'closed';
  const isInTrial = !meta || meta.isTrial;

  if (!user) {
    return null;
  }

  return (
    <StyledNavbar
      className={classNames(className, navModeClass, overlayNavClass)}
      role="navigation"
    >
      {isSuperUser(user) && <SpoofingControl />}

      <StyledLogoContainer>
        <Link to="/overview">
          <StyledAppLogo
            type="icon"
            alt="An image of the Appcues logo, click to return to your dashboard."
          />
        </Link>
      </StyledLogoContainer>

      <WebNavItems />
      <hr />
      <NavbarSection>
        <FeatureGate feature={APPCUES_SIDEBAR_WIDGET}>
          {enabled => (enabled ? <WidgetLink /> : null)}
        </FeatureGate>
        <GetHelpLink />
      </NavbarSection>

      <hr />

      {isInTrial && (
        <CListRow
          is={Link}
          to={isInstalled ? '/subscription' : '/settings/installation'}
        >
          <NavTrialMeter
            flowsShownLimit={meta.flowsShownLimit}
            isInstalled={isInstalled}
          />
        </CListRow>
      )}

      <StyledSettingsContainer>
        <CListRow
          padding={SETTINGS_MENU_PADDING_PX}
          iconAlign="center"
          beforeIcon="fa-user"
          beforeElement={
            <AvatarImg width={20} height={20} avatarUrl={user.avatarUrl} />
          }
          afterElement={<IconExpandMenu title="arrow pointing forward" />}
          hasMenu
          caption={user.fullname || ''}
        >
          <Text bold truncate float="left">
            {label}
          </Text>
          <NavbarMenu label={label} />
        </CListRow>
      </StyledSettingsContainer>
    </StyledNavbar>
  );
};

const StyledSettingsContainer = styled.ul`
  background-color: white;
  line-height: ${SETTINGS_MENU_LINE_HEIGHT_PX}px;
  list-style: none;
  width: var(--nav-width);
  position: fixed;
  bottom: 0;
  left: 0;
  border: 1px solid ${props => props.theme['$dark-tint-10']};
  border-left: none;
`;

const StyledAppLogo = styled(CLogo)`
  max-height: 100%;
  height: 100%;
  margin: 0 auto;
  width: 20px;
`;

const StyledLogoContainer = styled.div`
  max-width: 60%;
  margin: 0 auto;
  margin-bottom: 45px;
  margin-top: 47px;
  text-align: center;
`;

const StyledNavbar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  flex-direction: column;
  overflow-y: auto;
  width: var(--nav-width);
  /* end nav container where settings container begins */
  height: 100%;
  min-height: 100%;
  padding-bottom: ${SETTINGS_MENU_PADDING_PX * 2 +
  SETTINGS_MENU_LINE_HEIGHT_PX * 2}px;
  z-index: 2;
  background-color: white;
  border-right: 1px solid ${props => props.theme['$dark-tint-10']};

  hr {
    width: 65%;
    border-color: #e1e5eb;
    border-top: none;
    margin: 0 auto;
    margin-top: 20px;
  }
  animation: transform 1s ease-out;

  &.overlay-nav.closed {
    transform: translateX(-100%);
    animation: transform 1s ease-in;
  }
  animation: transform 1s ease-out;

  &.overlay-nav.closed {
    transform: translateX(-100%);
    animation: transform 1s ease-in;
  }
  animation: transform 1s ease-out;

  &.overlay-nav.closed {
    transform: translateX(-100%);
    animation: transform 1s ease-in;
  }
`;

export default OldNavbar;
